import _ from "lodash";
import axios from "axios";

import { canaveral_url, sisi_api_url } from "../api";

export const searchRequestActivities = async ({ payload, onError }) => {
  try {
    const response = await axios.post(
      `${sisi_api_url}/activities/search/`,
      payload
    );

    return _.get(response, "data", {});
  } catch (error) {
    console.error(error);
    onError(error);
  }
  return null;
};

export const pollActivitiesSearch = async ({ session_id }) => {
  try {
    const response = await axios.get(
      `${sisi_api_url}/activities/search/${session_id}/`
    );

    return _.get(response, "data", {});
  } catch (error) {
    console.error(error);
    if (
      _.get(error, "response.data.status", "") === "done" ||
      _.get(error, "response.data.status", "") === "failed"
    ) {
      return "system_error";
    }
  }
  return null;
};

export const retrieveActivity = async ({ activity_uid, search_session_id }) => {
  try {
    const response = await axios.get(
      `${sisi_api_url}/activities/retrieve-activity/${search_session_id}/`,
      { params: { uid: activity_uid } }
    );

    return _.get(response, "data", {});
  } catch (error) {
    console.error(error);
  }
  return null;
};

export const retrieveDatesByPickup = async ({
  activity_uid,
  search_session_id,
  pickup_code,
}) => {
  try {
    const response = await axios.get(
      `${sisi_api_url}/activities/dates-by-pickup/${search_session_id}/`,
      { params: { uid: activity_uid, pickup_code } }
    );

    return _.get(response, "data", {});
  } catch (error) {
    console.error(error);
  }
  return null;
};

export const chooseDateForActivity = async ({
  activity_uid,
  date,
  search_session_id,
  pickup_code,
  onError,
}) => {
  try {
    const response = await axios.get(
      `${sisi_api_url}/activities/choose-date/${search_session_id}/`,
      { params: { date, uid: activity_uid, pickup_code } }
    );

    return _.get(response, "data", {});
  } catch (error) {
    if (typeof onError === "function") {
      onError(error);
    }
    console.error({ error });
  }
  return null;
};

export const preBook = async ({ data }) => {
  try {
    const response = await axios.post(
      `${sisi_api_url}/activities/prebook/`,
      data
    );
    return _.get(response, "data", {});
  } catch (error) {
    console.error(error);
  }
  return null;
};

export const preBookUpdate = async ({ payload, search_session_id }) => {
  try {
    const response = await axios.put(
      `${sisi_api_url}/activities/prebook/${search_session_id}`,
      payload
    );
    return _.get(response, "data", {});
  } catch (error) {
    console.error(error);
  }
  return null;
};

export const createBooking = async ({ payload }) => {
  try {
    const response = await axios.post(
      `${canaveral_url}/book-activity`,
      payload
    );
    return _.get(response, "data", {});
  } catch (error) {
    console.error(error);
  }
  return null;
};

export async function getActivitySupplierVoucher({
  activity_uuid,
  supplier_reservation_uid,
  provider,
  api_uid,
}) {
  try {
    const result = await axios.get(`${sisi_api_url}/activities/voucher/`, {
      params: {
        activity_uuid,
        supplier_reservation_uid,
        provider,
        api_uid,
      },
    });
    return result.data;
  } catch (error) {
    return null;
  }
}
